module.exports = __webpack_public_path__ + "img/docx.2b15af00.png";